import { motion } from "framer-motion";

import OctagonBadge from "./OctagonBadge";

const Badge3D = ({ badge, isEarned = false }) => {
  const gradientColors = badge.gradient || ["#6B7280", "#4B5563", "#9CA3AF"];
  const shadowColor = isEarned ? gradientColors[1] : "#1a1a1a";

  return (
    <div
      style={{
        width: "100%",
        height: "220px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        perspective: "800px",
        position: "relative",
      }}
    >
      {/* Badge */}
      <motion.div
        animate={{ rotateY: -30, rotateX: 20, scale: 1, opacity: 1 }}
        initial={{ rotateY: -30, rotateX: 20, scale: 0.5, opacity: 0 }}
        style={{
          transformStyle: "preserve-3d",
          position: "relative",
          zIndex: 1,
          filter: `drop-shadow(8px 12px 4px rgba(0,0,0,0.4)) drop-shadow(12px 16px 8px rgba(0,0,0,0.3)) drop-shadow(16px 24px 16px ${shadowColor}40)`,
        }}
        transition={{
          type: "spring",
          stiffness: 150,
          damping: 20,
        }}
      >
        <OctagonBadge
          badge={badge}
          isEarned={isEarned}
          showTooltip={false}
          size="lg"
        />
      </motion.div>
    </div>
  );
};

export default Badge3D;
